<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
    <g transform="translate(-447.25 -749)"><path d="M33,3H6.75A3.761,3.761,0,0,0,3,6.75V33a3.761,3.761,0,0,0,3.75,3.75H33A3.761,3.761,0,0,0,36.75,33V6.75A3.761,3.761,0,0,0,33,3ZM14.25,29.25H10.5V16.125h3.75Zm7.5,0H18V10.5h3.75Zm7.5,0H25.5v-7.5h3.75Z" transform="translate(449.875 751.625)"/><path class="a" d="M0,0H45V45H0Z" transform="translate(447.25 749)"/></g>
  </svg>
</template>

<script>
export default {
  name: 'b-icon-poll',
  components: {},
  computed: {},
  props: {},
}
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
	IconPoll

	```js
	<b-icon-poll />
	```
</docs>